/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Информация о банке
 */
export interface PaymentBank {
  /**
   * Идентификатор банка
   * @format uuid
   */
  id?: string;

  /**
   * Наименование банка
   * @example Россельхозбанк
   */
  name: string;

  /** Тип населенного пункта */
  placetype: string;

  /** Наименование населенного пункта */
  placename: string;

  /**
   * БИК банка
   * @example 044030910
   */
  bic: string;

  /**
   * Кор. счет банка
   * @example 30101810900000000910
   */
  corAccount?: string;
  adress?: string;

  /** @format int64 */
  countryId?: number;
  latAdress?: string;
  latName?: string;
  isResident?: boolean;
  swift?: string;
}

/**
 * Участник платежа
 */
export interface PaymentMember {
  /**
   * Идентификатор субъекта
   * @format uuid
   * @example c4b55aca-41b8-4708-9a36-dfc3090842d8
   */
  id: string;

  /**
   * Наименование субъекта
   * @example ООО Пример
   */
  name: string;

  /**
   * Номер счёта
   * @example 40702810935000001770
   */
  accountNumber: string;

  /**
   * ИНН
   * @example 7714698321
   */
  inn: string;

  /**
   * КПП
   * @example 771401001
   */
  kpp: string;

  /** Информация о банке */
  bank: PaymentBank;
}

/**
 * Данные формы шаблона
 */
export interface TemplateRequest {
  ignoreWarning?: boolean;

  /** Признак добавления получателя в справочник контрагентов */
  addCorrespondent?: boolean;

  /** Название шаблона */
  name: string;

  /** Сумма операции */
  amount?: number;

  /** Код вида документа */
  kind: string;

  /** Способ отправки */
  sendType: string;

  /**
   * Очередность
   * @format int32
   */
  priority: number;

  /** Участник платежа */
  payer: PaymentMember;

  /** Участник платежа */
  receiver: PaymentMember;

  /** Назначение платежа */
  ground: string;

  /** Признак налогового платежа */
  isTaxPayment: boolean;

  /** Статус отправителя */
  taxPayerStatus?: string;

  /** Код КБК */
  kbk?: string;

  /** Код ОКТМО */
  oktmo?: string;

  /** Код (УИН/УИП) */
  uin?: string;

  /** Условие оплаты */
  conditionPayment?: string;

  /** Срок для акцепта */
  acceptancePeriod?: string;

  /** Основание налогового платежа */
  taxPaymentGround?: string;

  /** Налоговый период */
  taxPeriod?: string;

  /** Номер документа */
  taxDocNumber?: string;

  /** Дата документа */
  taxDocDate?: string;

  /** Код выплат */
  payType?: string;

  /** Код вида дохода */
  incomeCode?: string;

  /** Удержано по исполнительному документу */
  holdByExecDocSum?: number;

  /** Код валютной операции */
  curOperKindCode?: string;

  /** Идентификатор платежного документа */
  communalServicesId?: string;

  /** Идентификатор услуги ЖКХ (ЖКУ) */
  communalServicesServiceId?: string;

  /** Номер платежного документа (ПДИ) */
  communalServicesDocNum?: string;

  /** Единый лицевой счет (ЕЛС) */
  communalServicesSpa?: string;

  /** Номер лицевого счета (ЛСИ) */
  communalServicesAccNum?: string;

  /** Период оплаты */
  communalServicesPeriod?: string;

  /** ИНН налогоплательщика (платеж за третье лицо) */
  innTaxPayer?: string;

  /** КПП налогоплательщика (платеж за третье лицо) */
  kppTaxPayer?: string;

  /** Наименование налогоплательщика (платеж за третье лицо) */
  taxPayerName?: string;

  /** Адрес налогоплательщика (платеж за третье лицо) */
  taxPayerAddress?: string;
}

export interface TemplateResponse {
  /** @format uuid */
  id?: string;
}

/**
 * Описание ошибки
 */
export interface ErrorMessage {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Информация о вложении
 */
export interface AttachmentSave {
  /**
   * Идентификатор вложения
   * @format uuid
   */
  id: string;
}

/**
 * Информация для валютного контроля о валютном платеже
 */
export interface CurrControlOperation {
  /**
   * Идентификатор договора/контракта
   * @format uuid
   */
  contractId?: string;

  /** Номер договора/контракта  */
  contractNumber?: string;

  /**
   * Дата договора/контракта
   * @format date
   */
  contractDate?: string;

  /** Уникальный номер контракта/кредитного договора  */
  contractUnk?: string;

  /** Сумма по коду вида операции */
  paySum?: number;

  /**
   * Код валюты
   * @example USD
   */
  payCurrency?: string;

  /**
   * Код валютной операции
   * @example 21200
   */
  kvo?: string;

  /**
   * Код валюты договора
   * @example USD
   */
  contractCurrency?: string;

  /** Сумма в валюте договора */
  contractCurrencySum?: number;

  /**
   * Ожидаемый срок
   * @format date
   */
  expectedDate?: string;

  /**
   * Срок возврата
   * @format date
   */
  refundDate?: string;

  /** Лимит операции */
  contractLimit?: boolean;

  /** Контрагенты */
  contractors?: CurrControlOperationContractor[];
}

export interface CurrControlOperationContractor {
  name?: string;
  countryNumCode?: string;
}

/**
 * Данные формы платежного документа
 */
export interface PaymentRequest {
  ignoreWarning?: boolean;
  addCorrespondent?: boolean;

  /**
   * Дата операции
   * @format date
   */
  date: string;

  /** Номер платежа */
  number: string;

  /** Сумма операции */
  amount: number;

  /** Код вида документа */
  kind: string;

  /** @format uuid */
  invoiceId?: string;

  /** Способ отправки */
  sendType: string;

  /**
   * Очередность
   * @format int32
   */
  priority: number;

  /** Участник платежа */
  payer: PaymentMember;

  /** Участник платежа */
  receiver: PaymentMember;

  /** Назначение платежа */
  ground: string;

  /** Признак налогового платежа */
  isTaxPayment: boolean;

  /** Данные по операциям для валютного контроля */
  currControlOperations?: CurrControlOperation[];

  /** Список вложений */
  attachments?: AttachmentSave[];
  taxPayerStatus?: string;
  kbk?: string;
  oktmo?: string;
  uin?: string;
  conditionPayment?: string;
  acceptancePeriod?: string;
  taxPaymentGround?: string;
  taxPeriod?: string;
  taxDocNumber?: string;
  taxDocDate?: string;
  payType?: string;
  incomeCode?: string;
  holdByExecDocSum?: number;
  curOperKindCode?: string;
  communalServicesId?: string;
  communalServicesServiceId?: string;
  communalServicesDocNum?: string;
  communalServicesSpa?: string;
  communalServicesAccNum?: string;
  communalServicesPeriod?: string;
  innTaxPayer?: string;
  kppTaxPayer?: string;
  taxPayerName?: string;
  taxPayerAddress?: string;
  ipAddress?: string;
  macAddress?: string;

  /** @format uuid */
  basisDocument?: string;
  paymentOrderType?: string;
  isEditable?: boolean;

  /** @format int32 */
  taxIncludeNds?: number;

  /** @format int32 */
  taxNdsSize?: number;
  externalPaymentSource?: string;
}

/**
 * Ошибка валидации
 */
export interface CheckErrorMessage {
  /** @format date-time */
  time?: string;
  errors?: CheckItem[];
  warnings?: CheckItem[];
}

export interface CheckItem {
  message?: string;
}

/**
 * Права доступа к документу
 */
export interface AccessRights {
  /** Редактирование документа */
  canEdit?: boolean;

  /** Разрешение подписать документ */
  canSign?: boolean;

  /** Разрешение на удаление документа */
  canDelete?: boolean;

  /** Разрешение на отзыв документа */
  canRevoke?: boolean;
}

/**
 * Краткая информация о документе
 */
export interface Document {
  /**
   * Идентификатор документа
   * @format uuid
   * @example 123e4567-e89b-12d3-a456-426614174000
   */
  id?: string;

  /**
   * Вид документа
   * @example PaymentOrder
   */
  kind?: string;

  /**
   * Номер документа
   * @example 123
   */
  number?: string;

  /**
   * Дата документа
   * @format date
   * @example 2022-07-15
   */
  date?: string;

  /**
   * Код статуса документа
   * @example NEW
   */
  state?: string;

  /**
   * Статус документа
   * @example Новый
   */
  stateDesc?: string;

  /** Права доступа к документу */
  accessRights?: AccessRights;

  /** Вложения */
  attachments?: AttachmentSave[];
}

/**
 * Запрос на создание реестра
 */
export interface NominalRegistryRequest {
  /**
   * Номер реестра
   * @example 123
   */
  registryNumber?: string;

  /**
   * Дата реестра
   * @format date
   * @example 2022-07-15
   */
  registryDate?: string;

  /**
   * Сумма реестра
   * @example 100500
   */
  totalSum?: number;

  /** Счет получателя */
  receiverAccountNumber?: string;

  /** Бик банка получателя */
  receiverBankBic?: string;

  /** Название банка получателя */
  receiverBankName?: string;

  /** Название получателя */
  receiverName?: string;

  /** ИНН получателя */
  receiverInn?: string;

  /** КПП получателя */
  receiverKpp?: string;

  /** Корсчет получателя */
  receiverCorAcc?: string;

  /** Основание платежа */
  ground?: string;

  /** Список подопечных */
  wards?: Ward[];

  /** Сохранить как черновик */
  isDraft?: boolean;
}

/**
 * Информация о подопечном
 */
export interface Ward {
  /**
   * Id записи подопечного в реестре
   * @format uuid
   */
  id?: string;

  /** ФИО подопечного */
  fio?: string;

  /** Номер счета подопечного */
  accountNumber?: string;

  /** Баланс счета подопечного */
  accountBalance?: number;

  /** Сумма списания со счета подопечного */
  sum?: number;
}

/**
 * Краткая информация о реестре
 */
export interface NominalRegistry {
  /**
   * Идентификатор реестра
   * @format uuid
   * @example 123e4567-e89b-12d3-a456-426614174000
   */
  id?: string;

  /**
   * Номер реестра
   * @example 123
   */
  registryNumber?: string;

  /**
   * Дата реестра
   * @format date
   * @example 2022-07-15
   */
  registryDate?: string;

  /**
   * Статус реестра
   * @example SIGNED
   */
  status?: string;

  /**
   * Сумма реестра
   * @example 100500
   */
  totalSum?: number;

  /** Счет получателя */
  receiverAccountNumber?: string;

  /** Бик банка получателя */
  receiverBankBic?: string;

  /** Название банка получателя */
  receiverBankName?: string;

  /** Название получателя */
  receiverName?: string;

  /** ИНН получателя */
  receiverInn?: string;

  /** КПП получателя */
  receiverKpp?: string;

  /** Корсчет получателя */
  receiverCorAcc?: string;

  /** Основание платежа */
  ground?: string;

  /** Комментарий банка */
  noteBank?: string;

  /** Список подопечных */
  wards?: Ward[];

  /** Права доступа к документу */
  accessRights?: AccessRights;
}

/**
 * Данные формы реестра
 */
export interface CreditRegistryRequest {
  /** Наименование заемщика */
  borrowerName?: string;

  /** Номер кредитного договора */
  agreementNumber?: string;

  /**
   * Дата кредитного договора
   * @format date
   */
  agreementDate?: string;

  /**
   * Id кредитного договора
   * @format uuid
   */
  agreementId?: string;

  /** Сумма кредита/транша */
  creditAmount: number;

  /** Номер заявления */
  applicationNumber?: string;

  /**
   * Дата заявления
   * @format date
   */
  applicationDate?: string;

  /** Расчетный счёт */
  accountNumber?: string;

  /** Валюта */
  currencyCode?: string;

  /** Реквизиты договоров контрагента */
  paymentDetailsList: PaymentDetails[];
}

/**
 * Детализация платежей
 */
export interface PaymentDetails {
  /**
   * Идентификатор платежного документа
   * @format uuid
   */
  documentId: string;

  /** Номер договора контагента */
  contractNumber: string;

  /**
   * Дата договора контагента
   * @format date
   */
  contractDate: string;

  /** Предмет договора */
  contractSubject: string;

  /** Сумма договора */
  contractAmount: number;

  /** ФИО подписанта договоров со стороны контрагента */
  counterpartyName: string;

  /** Должность подписанта договоров со стороны контрагента */
  counterpartyPosition: string;

  /** ФИО подписанта договоров со стороны заемщика */
  borrowerName: string;

  /** Должность подписанта договоров со стороны заемщика */
  borrowerPosition: string;

  /** Флаг массового подписания */
  massSigning?: boolean;

  /** Флаг включения в реестр кредитов */
  includedInCreditRegistry?: boolean;
}

/**
 * Краткая информация о реестре
 */
export interface CreditRegistry {
  /**
   * Идентификатор реестра
   * @format uuid
   * @example 123e4567-e89b-12d3-a456-426614174000
   */
  id?: string;

  /**
   * Номер реестра
   * @example 123
   */
  number?: string;

  /**
   * Дата реестра
   * @format date
   * @example 2022-07-15
   */
  date?: string;
}

/**
 * Параметры создания отзыва на платежный документ
 */
export interface RevokePaymentRequest {
  /**
   * Идентификатор платежного документа
   * @format uuid
   */
  id: string;

  /** Причина отзыва */
  reason: string;
}

/**
 * Краткая информация о созданном отзыве платежного документа
 */
export interface RevokePaymentResponse {
  /**
   * Идентификатор отзыва на платежный документ
   * @format uuid
   */
  id?: string;

  /** Номер отзыва на платежный документ */
  number?: string;

  /** Статус отзыва на платежный документ */
  state?: string;

  /** Права доступа к документу */
  accessRights?: AccessRights;
}

/**
 * Результат импорта документов из 1С
 */
export interface DocumentImport {
  /**
   * Количество документов в файле импорта
   * @format int32
   * @example 1
   */
  documentsCount?: number;

  /**
   * Количество загруженных документов
   * @format int32
   * @example 1
   */
  importedCount?: number;

  /**
   * Количество документов-черновиков
   * @format int32
   * @example 1
   */
  draftCount?: number;

  /** Список ошибок процесса импорта файла из 1С */
  errors?: ImportError[];

  /** Сумма импортированных платежей */
  importedSum?: number;

  /** Сумма неимпортированных платежей с ошибками */
  notImportedSum?: number;

  /** Сумма черновиков */
  draftSum?: number;
}

/**
 * Тип ошибки
 */
export interface ImportError {
  /** Тип ошибки */
  type?: "FATAL" | "HARD" | "ERROR" | "WARNING";

  /** Описание ошибки */
  message?: string;
}

/**
 * Информация о вложении
 */
export interface Attachment {
  /**
   * Идентификатор вложения
   * @format uuid
   */
  id: string;

  /** Внешний идентификатор документа */
  fileId: string;

  /** Имя файла */
  fileName: string;

  /** Готовность файла */
  ready: boolean;

  /** Код ошибки */
  errorCode?: string;

  /** Текст ошибки */
  errorDescription?: string;

  /**
   * Размер
   * @format int64
   */
  size?: number;
}

/**
 * Пустой ответ
 */
export type EmptyResponse = object;

/**
 * Данные о плательщике/получателе платежа в краткой информации о платеже
 */
export interface PaymentMemberShort {
  /** Наименование контрагента */
  name?: string;

  /** Номер счета */
  accountNumber?: string;

  /** ИНН контрагента */
  inn?: string;

  /** КПП контрагента */
  kpp?: string;

  /** БИК банка контрагента */
  bic?: string;

  /** Наименование банка контрагента */
  bankName?: string;
}

export interface TemplateShort {
  /** @format uuid */
  id: string;

  /** Данные о плательщике/получателе платежа в краткой информации о платеже */
  receiver: PaymentMemberShort;
  name: string;
  kind: string;

  /** @format int64 */
  legacyId?: number;
  isTransfer: boolean;
}

export interface TemplatesResponse {
  hasMore: boolean;
  data: TemplateShort[];
}

/**
 * Полная информация о шаблоне
 */
export interface TemplateInfo {
  /**
   * Идентификатор платёжного документа
   * @format uuid
   * @example d97a3ae7-b32a-4677-825b-58cfb1e67ed9
   */
  id: string;

  /**
   * Сумма операции
   * @example 1500
   */
  amount: number;

  /**
   * Код вида документа:     PAYMENT_ORDER   - ПП     PAYMENT_DEMAND  - ПТ     PAYMENT_INCASSO - ИП
   * @example PAYMENT_ORDER
   */
  kind: string;

  /**
   * Способ отправки:     EMPTY           - ПустоURGENT - СрочноELECTRONICALLY - ЭлектронноMAIL - ПочтойTELEGRAPH - Телеграфом
   * @example EMPTY
   */
  sendType: "EMPTY" | "URGENT" | "ELECTRONICALLY" | "MAIL" | "TELEGRAPH";

  /**
   * Очерёдность
   * @format int32
   * @example 0
   */
  priority: number;

  /** Участник платежа */
  payer: PaymentMember;

  /** Участник платежа */
  receiver: PaymentMember;

  /**
   * Назначение платежа
   * @example Пример платежа партнёру, без НДС
   */
  ground: string;

  /**
   * Признак налогового платежа
   * @example false
   */
  isTaxPayment: boolean;

  /**
   * Статус отправителя
   * @example Пример
   */
  taxPayerStatus?: string;

  /**
   * Код КБК
   * @example 5312
   */
  kbk?: string;

  /**
   * Код ОКТМО
   * @example 312312
   */
  oktmo?: string;

  /**
   * Код (УИН/УИП)
   * @example 83123182739
   */
  uin?: string;

  /**
   * Условие оплаты (только для ПТ):1 - без акцепта2 - с акцептом
   * @format int32
   * @example 1
   */
  conditionPayment?: 1 | 2;

  /**
   * Срок акцепта (только для ПТ):1,2,3,4,5
   * @format int32
   * @example 2
   */
  acceptancePeriod?: 1 | 2 | 3 | 4 | 5;

  /**
   * Основание налогового платежа
   * @example Пример
   */
  taxPaymentGround?: string;

  /**
   * Налоговый период
   * @example ПРИМЕР
   */
  taxPeriod?: string;

  /**
   * Номер налогового документа
   * @example 153
   */
  taxDocNumber?: string;

  /**
   * Дата налогового документа
   * @example 0
   */
  taxDocDate?: string;

  /**
   * Код выплат
   * @example 381092
   */
  payType?: string;

  /**
   * Код вида дохода
   * @example 7912
   */
  incomeCode?: string;

  /**
   * Удержано по исполнительному документу
   * @example 1321
   */
  holdByExecDocSum?: number;

  /**
   * Код валютной операции
   * @example 02010
   */
  curOperKindCode?: string;

  /**
   * Идентификатор платёжного документа
   * @example 412
   */
  communalServicesId?: string;

  /**
   * Идентификатор услуг ЖКХ (ЖКУ)
   * @example 213
   */
  communalServicesServiceId?: string;

  /**
   * Номер платежного документа (ПДИ)
   * @example 312
   */
  communalServicesDocNum?: string;

  /**
   * Единый лицевой счет (ЕЛС
   * @example 51235
   */
  communalServicesSpa?: string;

  /**
   * Номер лицевого счета (ЛСИ)
   * @example 312331
   */
  communalServicesAccNum?: string;

  /** Период оплаты */
  communalServicesPeriod?: string;

  /**
   * ИНН налогоплательщика (платеж за третье лицо)
   * @example 1234567890
   */
  innTaxPayer?: string;

  /**
   * КПП налогоплательщика (платеж за третье лицо)
   * @example 123456789
   */
  kppTaxPayer?: string;

  /**
   * Наименование налогоплательщика (платеж за третье лицо)
   * @example ООО Морской бриз
   */
  taxPayerName?: string;

  /**
   * Адрес налогоплательщика (платеж за третье лицо)
   * @example 171211, г. Тверь, ул.Паши Савельевой, д.38
   */
  taxPayerAddress?: string;
  name?: string;

  /** @format int64 */
  legacyId?: number;
  blockedForMassSignature?: boolean;
}

/**
 * Информация о платежном документе
 */
export interface RevokePaymentInfo {
  /**
   * Идентификатор платежного документа
   * @format uuid
   */
  id?: string;

  /** Номер платежного документа */
  number?: string;

  /**
   * Дата платежного документа
   * @format date
   */
  date?: string;

  /** Вид платежного документа */
  kind?: string;

  /** Сумма платежа */
  amount?: number;

  /** Валюта платежа */
  currency?: string;

  /** Наименование получателя платежа */
  correspondent?: string;

  /** Назначение платежа */
  ground?: string;

  /** Признак "Между счетами" */
  isTransfer?: boolean;
}

/**
 * Полная информация о отзыве на платежный документ
 */
export interface RevokePaymentInfoResponse {
  /**
   * Идентификатор отзыва на платежный документ
   * @format uuid
   */
  id?: string;

  /** Номер отзыва на платежный документ */
  number?: string;

  /** Тип документа */
  type?: string;

  /** Статус отзыва на платежный документ */
  state?: string;

  /** Причина отзыва на платежный документ */
  reason?: string;

  /** Информация о платежном документе */
  payment?: RevokePaymentInfo;

  /** Права доступа к документу */
  accessRights?: AccessRights;
}

/**
 * Досупные операции для документа
 */
export interface DocumentPermission {
  /** Имя операции */
  name: string;

  /** Описание операции */
  desc: string;

  /** Доступность операции */
  isAvailable?: boolean;
}

/**
 * Информация о связи
 */
export interface Link {
  /**
   * Идентификатор объекта, создателя связи
   * @format uuid
   */
  ownerId?: string;

  /** Тип объекта, создателя связи */
  ownerType?: string;

  /** Идентификатор связанного объекта */
  referenceId?: string;

  /** Тип связанного объекта */
  referenceType?: string;
}

/**
 * Полная информация о документе
 */
export interface PaymentInfo {
  /**
   * Идентификатор платёжного документа
   * @format uuid
   * @example d97a3ae7-b32a-4677-825b-58cfb1e67ed9
   */
  id: string;

  /**
   * Сумма операции
   * @example 1500
   */
  amount: number;

  /**
   * Код вида документа:     PAYMENT_ORDER   - ПП     PAYMENT_DEMAND  - ПТ     PAYMENT_INCASSO - ИП
   * @example PAYMENT_ORDER
   */
  kind: string;

  /**
   * Способ отправки:     EMPTY           - ПустоURGENT - СрочноELECTRONICALLY - ЭлектронноMAIL - ПочтойTELEGRAPH - Телеграфом
   * @example EMPTY
   */
  sendType: "EMPTY" | "URGENT" | "ELECTRONICALLY" | "MAIL" | "TELEGRAPH";

  /**
   * Очерёдность
   * @format int32
   * @example 0
   */
  priority: number;

  /** Участник платежа */
  payer: PaymentMember;

  /** Участник платежа */
  receiver: PaymentMember;

  /**
   * Назначение платежа
   * @example Пример платежа партнёру, без НДС
   */
  ground: string;

  /**
   * Признак налогового платежа
   * @example false
   */
  isTaxPayment: boolean;

  /**
   * Статус отправителя
   * @example Пример
   */
  taxPayerStatus?: string;

  /**
   * Код КБК
   * @example 5312
   */
  kbk?: string;

  /**
   * Код ОКТМО
   * @example 312312
   */
  oktmo?: string;

  /**
   * Код (УИН/УИП)
   * @example 83123182739
   */
  uin?: string;

  /**
   * Условие оплаты (только для ПТ):1 - без акцепта2 - с акцептом
   * @format int32
   * @example 1
   */
  conditionPayment?: 1 | 2;

  /**
   * Срок акцепта (только для ПТ):1,2,3,4,5
   * @format int32
   * @example 2
   */
  acceptancePeriod?: 1 | 2 | 3 | 4 | 5;

  /**
   * Основание налогового платежа
   * @example Пример
   */
  taxPaymentGround?: string;

  /**
   * Налоговый период
   * @example ПРИМЕР
   */
  taxPeriod?: string;

  /**
   * Номер налогового документа
   * @example 153
   */
  taxDocNumber?: string;

  /**
   * Дата налогового документа
   * @example 0
   */
  taxDocDate?: string;

  /**
   * Код выплат
   * @example 381092
   */
  payType?: string;

  /**
   * Код вида дохода
   * @example 7912
   */
  incomeCode?: string;

  /**
   * Удержано по исполнительному документу
   * @example 1321
   */
  holdByExecDocSum?: number;

  /**
   * Код валютной операции
   * @example 02010
   */
  curOperKindCode?: string;

  /**
   * Идентификатор платёжного документа
   * @example 412
   */
  communalServicesId?: string;

  /**
   * Идентификатор услуг ЖКХ (ЖКУ)
   * @example 213
   */
  communalServicesServiceId?: string;

  /**
   * Номер платежного документа (ПДИ)
   * @example 312
   */
  communalServicesDocNum?: string;

  /**
   * Единый лицевой счет (ЕЛС
   * @example 51235
   */
  communalServicesSpa?: string;

  /**
   * Номер лицевого счета (ЛСИ)
   * @example 312331
   */
  communalServicesAccNum?: string;

  /** Период оплаты */
  communalServicesPeriod?: string;

  /**
   * ИНН налогоплательщика (платеж за третье лицо)
   * @example 1234567890
   */
  innTaxPayer?: string;

  /**
   * КПП налогоплательщика (платеж за третье лицо)
   * @example 123456789
   */
  kppTaxPayer?: string;

  /**
   * Наименование налогоплательщика (платеж за третье лицо)
   * @example ООО Морской бриз
   */
  taxPayerName?: string;

  /**
   * Адрес налогоплательщика (платеж за третье лицо)
   * @example 171211, г. Тверь, ул.Паши Савельевой, д.38
   */
  taxPayerAddress?: string;

  /**
   * Дата платёжного документа
   * @format date
   * @example 2022-08-30
   */
  date: string;

  /**
   * Дата отправки в банк
   * @format date-time
   */
  acceptedDate?: string;

  /**
   * Номер документа
   * @example 101
   */
  number: string;

  /**
   * Буквенный ISO-код валюты
   * @example RUB
   */
  currency: string;

  /**
   * Буквенный код статуса документа
   * @example NEW
   */
  state: string;

  /**
   * Комментарий банка при отказе обработки в анитифрод или АБС
   * @example NEW
   */
  bankComment?: string;

  /**
   * Комментарий банка
   * @example Отказ по причине не корректного номера КПП получателя
   */
  noteBank?: string;

  /**
   * Ссылка на идентификатор заявления на отзыв документа
   * @format uuid
   * @example 518efa52-ad68-11ed-afa1-0242ac120002
   */
  revokeId?: string;

  /** Доступные операции */
  permissions?: DocumentPermission[];

  /** Операции валютного контроля */
  currControlOperations?: CurrControlOperation[];

  /** Связи с другими документами */
  links?: Link[];

  /** Список вложений */
  attachments?: Attachment[];

  /** Признак включения документа в кредитный реестр */
  inCreditRegistry?: boolean;

  /**
   * Id в монолите
   * @format int64
   */
  legacyId?: number;
  blockedForMassSignature?: boolean;

  /** Признак создания через бухгалтерию Мое Дело */
  isMyBusinessPayment?: boolean;
}

/**
 * Действие над платежным документом
 */
export interface PaymentHistoryItem {
  /** Действие, совершённое над платежным документом */
  executedAction?: string;

  /**
   * Дата и время (в миллисекундах) совершения действия над платежным документом
   * @format int64
   */
  executedDate?: number;

  /** Сотрудник, выполнивший действие над платежным документом */
  executor?: string;
}

/**
 * История платежного документа
 */
export interface PaymentHistoryResponse {
  /** Список действий в истории платежного документа */
  historyList?: PaymentHistoryItem[];
}

export interface PaymentShort {
  /** @format uuid */
  id: string;
  number: string;

  /** @format date-time */
  date: string;

  /** Данные о плательщике/получателе платежа в краткой информации о платеже */
  payer: PaymentMemberShort;

  /** Данные о плательщике/получателе платежа в краткой информации о платеже */
  receiver: PaymentMemberShort;
  amount: number;
  currency: string;
  kind: string;
  state: string;
  ground: string;
  executedDate?: string;
  isMyBusinessPayment?: boolean;
}

export interface PaymentsResponse {
  hasMore: boolean;
  data: PaymentShort[];
}

/**
 * Информация о подразделении банка
 */
export interface Branch {
  /** @format uuid */
  id: string;
  name: string;
  bic: string;
  bankCorrespondentAccount: string;
  address?: string;
}

/**
 * Информация о клиенте
 */
export interface ClientInfo {
  /**
   * Идентификатор клиента
   * @format uuid
   * @example 28f48399-6d9c-4c7d-afb5-de3dc6040741
   */
  id: string;

  /**
   * AbsId клиента
   * @example 1234567890
   */
  absId: string;

  /**
   * Полное наименование  клиента
   * @example Общество с ограниченной ответственностью Ромашка
   */
  name: string;

  /**
   * Краткое наименование клиента
   * @example ООО Ромашка
   */
  shortName: string;

  /**
   * ИНН
   * @example 1234567890
   */
  inn: string;

  /**
   * КПП
   * @example 123456001
   */
  kpp?: string;

  /**
   * Заблокирована ли организация по 115 ФЗ?
   * @example false
   */
  isClientBlockedSFM?: boolean;

  /** Информация о подразделении банка */
  branch?: Branch;
}

/**
 * Подробная информация о начислении полученному из ГИС ГМП по УИН
 */
export interface PaymentChargingResponse {
  /**
   * Дата операции
   * @format date-time
   */
  date?: string;

  /** Сумма операции */
  amount: number;

  /** Буквенный ISO-код валюты */
  currency: string;

  /** Способ отправки:     EMPTY           - Пусто     URGENT          - Срочно     ELECTRONICALLY  - Электронно     MAIL            - Почтой     TELEGRAPH       - Телеграфом  */
  sendType: string;

  /**
   * Очередность
   * @format int32
   */
  priority: number;

  /** Участник платежа */
  payer: PaymentMember;

  /** Участник платежа */
  receiver: PaymentMember;

  /** Назначение платежа */
  ground: string;

  /** Признак налогового платежа */
  isTaxPayment: boolean;

  /** Статус отправителя */
  taxPayerStatus?: string;

  /** Код КБК */
  kbk?: string;

  /** Код ОКТМО */
  oktmo?: string;

  /** Код (УИН/УИП) */
  uin?: string;

  /** Основание налогового платежа */
  taxPaymentGround?: string;

  /** Налоговый период */
  taxPeriod?: string;

  /** Номер документа */
  taxDocNumber?: string;

  /** Дата документа */
  taxDocDate?: string;

  /** Код выплат */
  payType?: string;

  /** Код вида дохода */
  incomeCode?: string;

  /** Удержано по исполнительному документу */
  holdByExecDocSum?: number;

  /** Код валютной операции */
  curOperKindCode?: string;

  /** ИНН налогоплательщика (платеж за третье лицо)  */
  innTaxPayer?: string;

  /** КПП налогоплательщика (платеж за третье лицо)  */
  kppTaxPayer?: string;

  /** Наименование налогоплательщика (платеж за третье лицо)  */
  taxPayerName?: string;

  /** Адрес налогоплательщика (платеж за третье лицо)  */
  taxPayerAddress?: string;
}

/**
 * Следующий свободный номер платежного документа
 */
export interface NextDocumentNumberResponse {
  /** Следующий свободный номер платежного документа */
  documentNumber: string;
}

export interface WardSearchDto {
  /** ФИО подопечного */
  fio?: string;

  /** Номер счета подопечного */
  accountNumber?: string;

  /** Баланс счета подопечного */
  accountBalance?: number;
}

/**
 * Контракт клиента
 */
export interface ClientContract {
  /**
   * Идентификатор контракта
   * @format uuid
   */
  id?: string;

  /** Номер контракта */
  contractNumber?: string;

  /**
   * Дата контракта
   * @format date
   */
  contractDate?: string;

  /**
   * Дата окончания контракта
   * @format date
   */
  contractCloseDate?: string;

  /** Номер контракта в абс */
  contractAbsId?: string;

  /** Тип контракта */
  contractKind?: string;
}

/**
 * ККБ платежного документа
 */
export interface CcbDocument {
  /** ККБ платежного документа */
  fields?: CcbDocument;

  /** Тип документа */
  type?: DocumentType;
}

/**
 * Получение ккб конкретного документа
 */
export interface DocumentCcbResponse {
  /** Документ ККБ */
  ccb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** ККБ платежного документа */
  document?: CcbDocument;
}

/**
 * Тип документа
 */
export interface DocumentType {
  name?: string;
  desc?: string;
}

export interface NominalRegistryListResponse {
  hasMore: boolean;
  data: NominalRegistryShort[];
}

export interface NominalRegistryShort {
  /** @format uuid */
  id?: string;
  contractId?: string;
  registryNumber?: string;

  /** @format date */
  registryDate?: string;

  /** Статус реестра номинальных счетов */
  status?: NominalRegistryStatus;
  totalSum?: number;

  /** @format date-time */
  createDate?: string;
  receiverAccountNumber?: string;
  receiverBankBic?: string;
  receiverBankName?: string;
  receiverName?: string;
  receiverInn?: string;
  receiverKpp?: string;
  receiverCorAcc?: string;
  ground?: string;

  /** Права доступа к документу */
  accessRights?: AccessRights;
}

/**
 * Статус реестра номинальных счетов
 */
export interface NominalRegistryStatus {
  /** Статус реестра */
  status?: string;
}

/**
 * Значение справочника
 */
export interface DictValue {
  /**
   * Идентификатор значения справочника
   * @format uuid
   * @example 123e4567-e89b-12d3-a456-426614174000
   */
  id?: string;

  /**
   * Вид справочника
   * @example TaxPayerState
   */
  kind?: string;

  /**
   * Значение справочника
   * @example 04
   */
  code?: string;

  /**
   * Описание значения справочника
   * @example Налоговый орган
   */
  description?: string;

  /**
   * Значение справочника неактивно
   * @example false
   */
  inactive?: string;
}

/**
 * Информация о валюте
 */
export interface Currency {
  /**
   * Идентификатор
   * @format uuid
   * @example a1a5083b-750b-11ec-b8c4-97ca1919835d
   */
  id?: string;

  /**
   * Наименование
   * @example российский рубль
   */
  name?: string;

  /**
   * Буквенный код ISO
   * @example RUB
   */
  codeStr?: string;

  /**
   * Цифровой код ISO
   * @example 643
   */
  codeNum?: string;
}

/**
 * Детальная информация о кредитном реестре
 */
export interface CreditRegistryInfo {
  /**
   * Id реестра
   * @format uuid
   */
  id?: string;

  /** Номер реестра */
  registryNumber?: string;

  /** Статус реестра */
  status?: string;

  /** Сумма кредита/транша */
  creditAmount?: number;

  /** Наименование заемщика */
  borrowerName?: string;

  /** Номер кредитного договора */
  agreementNumber?: string;

  /**
   * Дата кредитного договора
   * @format date
   */
  agreementDate?: string;

  /** Валюта кредитного реестра */
  currencyCode?: string;

  /** Расчетный счёт */
  accountNumber?: string;

  /** Номер заявления */
  applicationNumber?: string;

  /**
   * Дата заявления
   * @format date
   */
  applicationDate?: string;

  /** Признак подписания реестра пользователем */
  signedByUser?: boolean;

  /** Реквизиты договоров контрагента */
  paymentDetailsInfo?: PaymentDetailsInfo[];
}

/**
 * Дополнительная информация о платеже внутри кредитного реестра
 */
export interface PaymentDetailsInfo {
  /** @format uuid */
  documentId?: string;
  documentNumber?: string;
  state?: string;

  /** @format date */
  date?: string;
  amount?: number;
  currency?: string;
  receiverName?: string;
  receiverInn?: string;
  receiverKpp?: string;
  receiverAccountNumber?: string;
  receiverBankBic?: string;
  receiverBankName?: string;
  contractNumber?: string;

  /** @format date */
  contractDate?: string;
  contractSubject?: string;
  contractAmount?: number;
  counterpartyName?: string;
  counterpartyPosition?: string;
  borrowerName?: string;
  borrowerPosition?: string;
  signedByUser?: boolean;
  inCreditRegistry?: boolean;
}

export interface CreditRegistryListResponse {
  hasMore: boolean;
  data: CreditRegistryShort[];
}

export interface CreditRegistryShort {
  /** @format uuid */
  id?: string;
  registryNumber?: string;
  status?: string;
  applicationNumber?: string;

  /** @format date */
  applicationDate?: string;
  creditAmount?: number;
  currencyCode?: string;
  allPrepared?: boolean;
}

/**
 * Информация о кредитном договоре
 */
export interface CreditAgreement {
  /**
   * Идентификатор
   * @format uuid
   * @example a1a5083b-750b-11ec-b8c4-97ca1919835d
   */
  id?: string;

  /** Идентификатор договора в ЦФТ */
  productId?: string;

  /** АБС идентификатор клиента в ЦФТ */
  absId?: string;

  /**
   * Код филиала
   * @example 3500
   */
  branchCode?: string;

  /**
   * Номер договора
   * @example 130
   */
  agreementNumber?: string;

  /**
   * Дата договора
   * @format date
   * @example 2022-08-30
   */
  agreementDate?: string;

  /**
   * Сумма договора
   * @example 45000
   */
  creditAmount?: number;

  /**
   * Буквенный код ISO
   * @example RUB
   */
  currency?: string;
}

/**
 * Статус документа со списком подписантов
 */
export interface DocumentStateResponse {
  state?: string;
  desc?: string;
  confirm?: Signatories[];
}

/**
 * Информация о подписанте
 */
export interface Signatories {
  /** Полное имя */
  fullName?: string;

  /** userExtId из jwt токена */
  userId?: string;

  /** Позиция */
  position?: string;

  /**
   * Дата подписи
   * @format date-time
   */
  signDate?: string;
}

/**
 * Получение типа подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId: string;
}

export interface BankListResponse {
  hasMore: boolean;
  data: PaymentBank[];
}

/**
 * Счет клиента
 */
export interface Account {
  /**
   * Идентификатор счета
   * @format uuid
   */
  id?: string;

  /** Состояние счета (открыт/закрыт) */
  state?: string;

  /**
   * Название
   * @example ООО Ромашка
   */
  name?: string;

  /**
   * Валюта счета
   * @example USD
   */
  currency?: string;

  /**
   * Номер счета
   * @example 40802810235000000520
   */
  number?: string;

  /**
   * Доступный остаток
   * @example 26950
   */
  availableBalance?: number;

  /** Тип счета (расчетный, депозитный, etc) */
  type?: string;

  /**
   * Дата открытия счета
   * @format date
   */
  openDate?: string;

  /**
   * Дата закрытия счета
   * @format date
   */
  closeDate?: string;

  /** Наименование филиала, в котором открыт счет */
  branchName?: string;

  /** Код филиала, в котором открыт счет */
  branchCode?: string;

  /** Признак, что этот счет используется по умолчанию */
  isDefaultAccount?: boolean;

  /** Признак, что этот счет в избранных */
  isFavouriteAccount?: boolean;

  /** Признак, что этот счет может быть в плательщиках */
  inPayerAccounts?: boolean;

  /** Признак, что этот счет может быть в получателях */
  inReceiverAccounts?: boolean;

  /** Блок данных по собственнику счета */
  wardInfo?: WardInfo;
}

/**
 * Блок данных по собственнику счета
 */
export interface WardInfo {
  /** Имя собственника счета */
  wardFirstName?: string;

  /** Фамилия собственника счета */
  wardLastName?: string;

  /** Отчество собственника счета */
  wardMiddleName?: string;
}

export interface CardIndexItem {
  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Наименование получателя */
  receiverName?: string;

  /** Сумма */
  initialAmount?: number;

  /** Баланс */
  balance?: number;

  /** Назначение */
  ground?: string;

  /** Валюта */
  currency?: string;

  /**
   * Идентификатор документа в МС РКО
   * @format uuid
   */
  parentDocumentId?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-rko-payments
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://127.0.0.1:8080
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Рублевые платёжные документы <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=74524107)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Шаблоны
     * @name GetTemplate
     * @summary Получение шаблона
     * @request GET:/api/rko-payments/v1/external/templates/{templateId}
     * @secure
     */
    getTemplate: (templateId: string, params: RequestParams = {}) =>
      this.request<TemplateInfo, ErrorMessage>({
        path: `/api/rko-payments/v1/external/templates/${templateId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Шаблоны
     * @name PutTemplate
     * @summary Редактирование шаблона
     * @request PUT:/api/rko-payments/v1/external/templates/{templateId}
     * @secure
     */
    putTemplate: (
      templateId: string,
      data: TemplateRequest,
      params: RequestParams = {}
    ) =>
      this.request<TemplateResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/templates/${templateId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Шаблоны
     * @name DeleteTemplate
     * @summary Удаление шаблона
     * @request DELETE:/api/rko-payments/v1/external/templates/{templateId}
     * @secure
     */
    deleteTemplate: (templateId: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/templates/${templateId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Платёжные документы
     * @name GetPayment
     * @summary Получение платёжного документа
     * @request GET:/api/rko-payments/v1/external/payment/{paymentId}
     * @secure
     */
    getPayment: (paymentId: string, params: RequestParams = {}) =>
      this.request<PaymentInfo, ErrorMessage>({
        path: `/api/rko-payments/v1/external/payment/${paymentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Платёжные документы
     * @name PutPayment
     * @summary Редактирование платёжного документа
     * @request PUT:/api/rko-payments/v1/external/payment/{paymentId}
     * @secure
     */
    putPayment: (
      paymentId: string,
      data: PaymentRequest,
      params: RequestParams = {}
    ) =>
      this.request<Document, ErrorMessage | CheckErrorMessage>({
        path: `/api/rko-payments/v1/external/payment/${paymentId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Платёжные документы
     * @name DeletePayment
     * @summary Удаление платёжного документа
     * @request DELETE:/api/rko-payments/v1/external/payment/{paymentId}
     * @secure
     */
    deletePayment: (paymentId: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/payment/${paymentId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры номинальных счетов
     * @name GetNominalRegistry
     * @summary Получение реестра
     * @request GET:/api/rko-payments/v1/external/nominal/registry/{nominalRegistryId}
     * @secure
     */
    getNominalRegistry: (
      nominalRegistryId: string,
      params: RequestParams = {}
    ) =>
      this.request<NominalRegistry, ErrorMessage>({
        path: `/api/rko-payments/v1/external/nominal/registry/${nominalRegistryId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры номинальных счетов
     * @name PutNominalRegistry
     * @summary Редактирование реестра
     * @request PUT:/api/rko-payments/v1/external/nominal/registry/{nominalRegistryId}
     * @secure
     */
    putNominalRegistry: (
      nominalRegistryId: string,
      data: NominalRegistryRequest,
      params: RequestParams = {}
    ) =>
      this.request<NominalRegistry, ErrorMessage>({
        path: `/api/rko-payments/v1/external/nominal/registry/${nominalRegistryId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры номинальных счетов
     * @name DeleteNominalRegistry
     * @summary Удаление реестра
     * @request DELETE:/api/rko-payments/v1/external/nominal/registry/{nominalRegistryId}
     * @secure
     */
    deleteNominalRegistry: (
      nominalRegistryId: string,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/nominal/registry/${nominalRegistryId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры кредитных договоров
     * @name GetCreditRegistry
     * @summary Получение реестра
     * @request GET:/api/rko-payments/v1/external/credits/registry/{creditRegistryId}
     * @secure
     */
    getCreditRegistry: (creditRegistryId: string, params: RequestParams = {}) =>
      this.request<CreditRegistryInfo, ErrorMessage>({
        path: `/api/rko-payments/v1/external/credits/registry/${creditRegistryId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры кредитных договоров
     * @name PutCreditRegistry
     * @summary Редактирование реестра
     * @request PUT:/api/rko-payments/v1/external/credits/registry/{creditRegistryId}
     * @secure
     */
    putCreditRegistry: (
      creditRegistryId: string,
      data: CreditRegistryRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreditRegistry, ErrorMessage>({
        path: `/api/rko-payments/v1/external/credits/registry/${creditRegistryId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры кредитных договоров
     * @name DeleteCreditRegistry
     * @summary Удаление реестра
     * @request DELETE:/api/rko-payments/v1/external/credits/registry/{creditRegistryId}
     * @secure
     */
    deleteCreditRegistry: (
      creditRegistryId: string,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/credits/registry/${creditRegistryId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Шаблоны
     * @name TemplatesGet
     * @summary Список шаблонов
     * @request GET:/api/rko-payments/v1/external/templates
     * @secure
     */
    templatesGet: (
      query?: {
        documentType?:
          | "PAYMENT_ORDER"
          | "PAYMENT_DEMAND"
          | "PAYMENT_INCASSO"
          | "REVOKE"
          | "CREDIT_REGISTRY"
          | "CREDIT_REGISTRY_REVOKE"
          | "PAYMENT_TEMPLATE"
          | "NOMINAL_REGISTRY";
        position?: number;
        size?: number;
        searchText?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TemplatesResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/templates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Шаблоны
     * @name CreateTemplate
     * @summary Создание шаблона
     * @request POST:/api/rko-payments/v1/external/templates
     * @secure
     */
    createTemplate: (data: TemplateRequest, params: RequestParams = {}) =>
      this.request<TemplateResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/templates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отзыв платежного документа
     * @name CreateRevokePayment
     * @summary Создание отзыва платежного документа
     * @request POST:/api/rko-payments/v1/external/revokes
     * @secure
     */
    createRevokePayment: (
      data: RevokePaymentRequest,
      params: RequestParams = {}
    ) =>
      this.request<RevokePaymentResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/revokes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Платёжные документы
     * @name CreatePayment
     * @summary Создание платёжного документа
     * @request POST:/api/rko-payments/v1/external/payment
     * @secure
     */
    createPayment: (data: PaymentRequest, params: RequestParams = {}) =>
      this.request<Document, ErrorMessage | CheckErrorMessage>({
        path: `/api/rko-payments/v1/external/payment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры номинальных счетов
     * @name CreateNominalRegistry
     * @summary Создание реестра
     * @request POST:/api/rko-payments/v1/external/nominal/registry
     * @secure
     */
    createNominalRegistry: (
      data: NominalRegistryRequest,
      params: RequestParams = {}
    ) =>
      this.request<NominalRegistry, ErrorMessage>({
        path: `/api/rko-payments/v1/external/nominal/registry`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Импорт документов
     * @name LegacyImport1C
     * @summary Импорт документов из 1С
     * @request POST:/api/rko-payments/v1/external/import/1c
     * @secure
     */
    legacyImport1C: (data: { file: File }, params: RequestParams = {}) =>
      this.request<DocumentImport, ErrorMessage>({
        path: `/api/rko-payments/v1/external/import/1c`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Импорт документов
     * @name Import1C
     * @summary Импорт документов из 1С
     * @request POST:/api/rko-payments/v1/external/import/1c/{mode}
     * @secure
     */
    import1C: (
      mode: string,
      data: { file: File },
      params: RequestParams = {}
    ) =>
      this.request<DocumentImport, ErrorMessage>({
        path: `/api/rko-payments/v1/external/import/1c/${mode}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name Download
     * @summary Получение файла
     * @request GET:/api/rko-payments/v1/external/file
     * @secure
     */
    download: (query: { id: string }, params: RequestParams = {}) =>
      this.request<File, ErrorMessage>({
        path: `/api/rko-payments/v1/external/file`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файлы
     * @name UploadFileAttachment
     * @summary Загрузка файла вложения
     * @request POST:/api/rko-payments/v1/external/file
     * @secure
     */
    uploadFileAttachment: (data: { file: File }, params: RequestParams = {}) =>
      this.request<Attachment, ErrorMessage>({
        path: `/api/rko-payments/v1/external/file`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры кредитных договоров
     * @name CreateCreditRegistry
     * @summary Создание реестра
     * @request POST:/api/rko-payments/v1/external/credits/registry
     * @secure
     */
    createCreditRegistry: (
      data: CreditRegistryRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreditRegistry, ErrorMessage>({
        path: `/api/rko-payments/v1/external/credits/registry`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры кредитных договоров
     * @name RevokeCreditRegistry
     * @summary Отзыв реестра
     * @request POST:/api/rko-payments/v1/external/credits/registry/revoke/{creditRegistryId}
     * @secure
     */
    revokeCreditRegistry: (
      creditRegistryId: string,
      params: RequestParams = {}
    ) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/credits/registry/revoke/${creditRegistryId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отзыв платежного документа
     * @name GetRevokePayment
     * @summary Получение отзыва на платежный документ
     * @request GET:/api/rko-payments/v1/external/revokes/{revokeId}
     * @secure
     */
    getRevokePayment: (revokeId: string, params: RequestParams = {}) =>
      this.request<RevokePaymentInfoResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/revokes/${revokeId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Платёжные документы
     * @name CheckDocumentPaymentDate
     * @summary Проверка даты создания платёжного документа
     * @request GET:/api/rko-payments/v1/external/payment/{paymentId}/check/document-date
     * @secure
     */
    checkDocumentPaymentDate: (paymentId: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/payment/${paymentId}/check/document-date`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Платёжные документы
     * @name ExtractPaymentPdf
     * @summary Получение печатной формы в формате PDF
     * @request GET:/api/rko-payments/v1/external/payment/print/{paymentId}
     * @secure
     */
    extractPaymentPdf: (paymentId: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/rko-payments/v1/external/payment/print/${paymentId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Платёжные документы
     * @name GetPaymentHistory
     * @summary Получение истории изменения платежного документа
     * @request GET:/api/rko-payments/v1/external/payment/history/{paymentId}
     * @secure
     */
    getPaymentHistory: (paymentId: string, params: RequestParams = {}) =>
      this.request<PaymentHistoryResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/payment/history/${paymentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Платёжные документы
     * @name PaymentsGet
     * @summary Список платежных документов
     * @request GET:/api/rko-payments/v1/external/payment/documents
     * @secure
     */
    paymentsGet: (
      query: {
        documentType:
          | "PAYMENT_ORDER"
          | "PAYMENT_DEMAND"
          | "PAYMENT_INCASSO"
          | "REVOKE"
          | "CREDIT_REGISTRY"
          | "CREDIT_REGISTRY_REVOKE"
          | "PAYMENT_TEMPLATE"
          | "NOMINAL_REGISTRY";
        position?: number;
        size?: number;
        searchText?: string;
        stateList?: string[];
        documentList?: string[];
        beginDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaymentsResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/payment/documents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Платёжные документы
     * @name GetPaymentList
     * @summary Получение списка платежных документов по их идентификаторам
     * @request GET:/api/rko-payments/v1/external/payment/document-list
     * @secure
     */
    getPaymentList: (
      query: { paymentList: string[] },
      params: RequestParams = {}
    ) =>
      this.request<PaymentShort[], ErrorMessage>({
        path: `/api/rko-payments/v1/external/payment/document-list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Платёжные документы
     * @name GetPaymentCopy
     * @summary Копирование платежного документа
     * @request GET:/api/rko-payments/v1/external/payment/copy/{paymentId}
     * @secure
     */
    getPaymentCopy: (paymentId: string, params: RequestParams = {}) =>
      this.request<PaymentInfo, ErrorMessage>({
        path: `/api/rko-payments/v1/external/payment/copy/${paymentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Платёжные документы
     * @name GetPaymentClient
     * @summary Получение данный по клиенту
     * @request GET:/api/rko-payments/v1/external/payment/client
     * @secure
     */
    getPaymentClient: (params: RequestParams = {}) =>
      this.request<ClientInfo, ErrorMessage>({
        path: `/api/rko-payments/v1/external/payment/client`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Платёжные документы
     * @name GetPaymentChargeByUin
     * @summary Получение бюджетного ПП по УИН из ГИС ГМП
     * @request GET:/api/rko-payments/v1/external/payment/charge
     * @secure
     */
    getPaymentChargeByUin: (
      query: { uin: string },
      params: RequestParams = {}
    ) =>
      this.request<PaymentChargingResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/payment/charge`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контроллер для получения вакантного номера платёжного документа
     * @name GetNextDocumentNumber
     * @summary Получение следующего номера документа
     * @request GET:/api/rko-payments/v1/external/number/{documentType}
     * @secure
     */
    getNextDocumentNumber: (
      documentType:
        | "PAYMENT_ORDER"
        | "PAYMENT_DEMAND"
        | "PAYMENT_INCASSO"
        | "REVOKE"
        | "CREDIT_REGISTRY"
        | "CREDIT_REGISTRY_REVOKE"
        | "PAYMENT_TEMPLATE"
        | "NOMINAL_REGISTRY",
      params: RequestParams = {}
    ) =>
      this.request<NextDocumentNumberResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/number/${documentType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры номинальных счетов
     * @name FindWards
     * @summary Поиск подопечных
     * @request GET:/api/rko-payments/v1/external/nominal/registry/wards
     * @secure
     */
    findWards: (query: { search: string }, params: RequestParams = {}) =>
      this.request<WardSearchDto[], ErrorMessage>({
        path: `/api/rko-payments/v1/external/nominal/registry/wards`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры номинальных счетов
     * @name ExtractPaymentPdf1
     * @summary Получение печатной формы в формате PDF
     * @request GET:/api/rko-payments/v1/external/nominal/registry/print/pdf/{registryId}
     * @secure
     */
    extractPaymentPdf1: (registryId: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/rko-payments/v1/external/nominal/registry/print/pdf/${registryId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры номинальных счетов
     * @name GetNextNominalRegistryNumber
     * @summary Получение следующего номера реестра
     * @request GET:/api/rko-payments/v1/external/nominal/registry/get-document-number
     * @secure
     */
    getNextNominalRegistryNumber: (params: RequestParams = {}) =>
      this.request<string, ErrorMessage>({
        path: `/api/rko-payments/v1/external/nominal/registry/get-document-number`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры номинальных счетов
     * @name ExportNominalRegistryToExcel
     * @summary Экспорт в эксель номинального реестра
     * @request GET:/api/rko-payments/v1/external/nominal/registry/export/xls/{registryId}
     * @secure
     */
    exportNominalRegistryToExcel: (
      registryId: string,
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorMessage>({
        path: `/api/rko-payments/v1/external/nominal/registry/export/xls/${registryId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры номинальных счетов
     * @name GetClientFundContract
     * @summary Получение информации о консолидирующем контракте
     * @request GET:/api/rko-payments/v1/external/nominal/registry/contract
     * @secure
     */
    getClientFundContract: (params: RequestParams = {}) =>
      this.request<ClientContract, ErrorMessage | ClientContract>({
        path: `/api/rko-payments/v1/external/nominal/registry/contract`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры номинальных счетов
     * @name CheckNominalRegistry
     * @summary Проверка возможности дальнейшей обработки реестра
     * @request GET:/api/rko-payments/v1/external/nominal/registry/check-status
     * @secure
     */
    checkNominalRegistry: (params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/rko-payments/v1/external/nominal/registry/check-status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры номинальных счетов
     * @name GetNominalRegistryCcb
     * @summary Получение ккб реестра
     * @request GET:/api/rko-payments/v1/external/nominal/registry/ccb/{nominalRegistryId}
     * @secure
     */
    getNominalRegistryCcb: (
      nominalRegistryId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/nominal/registry/ccb/${nominalRegistryId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры номинальных счетов
     * @name GetNominalRegistryList
     * @summary Получение списка реестров
     * @request GET:/api/rko-payments/v1/external/nominal/registry/
     * @secure
     */
    getNominalRegistryList: (
      query: {
        search: string;
        position: number;
        size: number;
        stateList?: string[];
        beginDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<NominalRegistryListResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/nominal/registry/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация из справочников
     * @name GetDictValues
     * @summary Получить значения справочника
     * @request GET:/api/rko-payments/v1/external/dict/{kind}
     * @secure
     */
    getDictValues: (kind: string, params: RequestParams = {}) =>
      this.request<DictValue[], ErrorMessage>({
        path: `/api/rko-payments/v1/external/dict/${kind}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Валюты
     * @name GetCurrencies
     * @summary Получить список валют
     * @request GET:/api/rko-payments/v1/external/currency
     * @secure
     */
    getCurrencies: (params: RequestParams = {}) =>
      this.request<Currency[], ErrorMessage>({
        path: `/api/rko-payments/v1/external/currency`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры кредитных договоров
     * @name GetUpdatedCreditRegistryStatus
     * @summary Проверить статус реестра
     * @request GET:/api/rko-payments/v1/external/credits/registry/check-status/{creditRegistryId}
     * @secure
     */
    getUpdatedCreditRegistryStatus: (
      creditRegistryId: string,
      params: RequestParams = {}
    ) =>
      this.request<CreditRegistryInfo, ErrorMessage>({
        path: `/api/rko-payments/v1/external/credits/registry/check-status/${creditRegistryId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры кредитных договоров
     * @name GetCreditRegistryCcb
     * @summary Получение ккб реестра
     * @request GET:/api/rko-payments/v1/external/credits/registry/ccb/{creditRegistryId}
     * @secure
     */
    getCreditRegistryCcb: (
      creditRegistryId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/credits/registry/ccb/${creditRegistryId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестры кредитных договоров
     * @name GetCreditRegistryList
     * @summary Получение списка реестров
     * @request GET:/api/rko-payments/v1/external/credits/registry/
     * @secure
     */
    getCreditRegistryList: (
      query: {
        position: number;
        size: number;
        stateList?: string[];
        beginDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<CreditRegistryListResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/credits/registry/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Кредитные договоры
     * @name GetCreditAgreements
     * @summary Получение списка договоров
     * @request GET:/api/rko-payments/v1/external/credits/agreement
     * @secure
     */
    getCreditAgreements: (params: RequestParams = {}) =>
      this.request<CreditAgreement[], ErrorMessage>({
        path: `/api/rko-payments/v1/external/credits/agreement`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name RevokeAllSignatures
     * @summary Отозвать все подписи
     * @request GET:/api/rko-payments/v1/external/confirmation/revoke-all-signatures
     * @secure
     */
    revokeAllSignatures: (
      query: { documentId: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/rko-payments/v1/external/confirmation/revoke-all-signatures`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name GetDocumentState
     * @summary Статус платежного документа
     * @request GET:/api/rko-payments/v1/external/confirmation/document-state
     * @secure
     */
    getDocumentState: (
      query: { documentId: string; isNeedForceSignUpdate?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<DocumentStateResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/confirmation/document-state`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name GetDocumentCcb
     * @summary Ккб платежного документа
     * @request GET:/api/rko-payments/v1/external/confirmation/document-ccb
     * @secure
     */
    getDocumentCcb: (
      query: { documentId: string },
      params: RequestParams = {}
    ) =>
      this.request<DocumentCcbResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/confirmation/document-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из мс подтверждения
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/rko-payments/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификаты клиента
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/rko-payments/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Банки
     * @name GetBankListByBicOrName
     * @summary Список банков по бик и наименованию
     * @request GET:/api/rko-payments/v1/external/banks
     * @secure
     */
    getBankListByBicOrName: (
      query: { position?: number; size?: number; search: string },
      params: RequestParams = {}
    ) =>
      this.request<BankListResponse, ErrorMessage>({
        path: `/api/rko-payments/v1/external/banks`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета
     * @name GetAccounts
     * @summary Получить все счета клиента
     * @request GET:/api/rko-payments/v1/external/accounts
     * @secure
     */
    getAccounts: (params: RequestParams = {}) =>
      this.request<Account[], ErrorMessage>({
        path: `/api/rko-payments/v1/external/accounts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета
     * @name GetCardIndex
     * @summary Получение картотеки по счету
     * @request GET:/api/rko-payments/v1/external/accounts/statement-k2/{account}
     * @secure
     */
    getCardIndex: (account: string, params: RequestParams = {}) =>
      this.request<CardIndexItem[], ErrorMessage>({
        path: `/api/rko-payments/v1/external/accounts/statement-k2/${account}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета
     * @name RefreshAccounts
     * @summary Обновление счетов клиента
     * @request GET:/api/rko-payments/v1/external/accounts/refresh
     * @secure
     */
    refreshAccounts: (params: RequestParams = {}) =>
      this.request<void, ErrorMessage>({
        path: `/api/rko-payments/v1/external/accounts/refresh`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
